import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "label", "placeholder", "errorText", "disableErrorContainer", "name", "onChange", "disabled", "readOnly", "$css", "className", "hiddenLabel", "collapseError", "helperText"],
    _excluded2 = ["onBlur"];
import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { CaretDown } from '../../../svg';
import { InputElementStyles, InputWrapperStyles } from '../Input/BaseInput';
import { InputError } from '../Error';
import { useExtendedField } from '../../../../hooks';
import Label from '../../Label';
import { flex, isKeyboard, SPACINGS } from '../../../../styling';
import { addInputErrorAriaProps, dotToDash } from '../../../../utils';
import { Div } from '../../../Styled';
import { COLORS } from '../../../../themes';
import HelperText from '../../../text/HelperText';
var SelectWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Select__SelectWrapper",
  componentId: "sc-1e81aim-0"
})(["", ";position:relative;user-select:none;"], InputWrapperStyles);
var SelectElement = /*#__PURE__*/styled.select.withConfig({
  displayName: "Select__SelectElement",
  componentId: "sc-1e81aim-1"
})(["", ";padding:10px 40px 10px 16px;", ""], InputElementStyles, function (_ref) {
  var $hasValue = _ref.$hasValue;
  return !$hasValue && "color: ".concat(COLORS.NEUTRAL_500, ";");
});
var ArrowContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Select__ArrowContainer",
  componentId: "sc-1e81aim-2"
})(["pointer-events:none;position:absolute;right:1.6rem;top:0;bottom:0;", ";"], flex('center', 'center'));

var Select = function Select(_ref2) {
  var children = _ref2.children,
      label = _ref2.label,
      placeholder = _ref2.placeholder,
      errorText = _ref2.errorText,
      _ref2$disableErrorCon = _ref2.disableErrorContainer,
      disableErrorContainer = _ref2$disableErrorCon === void 0 ? false : _ref2$disableErrorCon,
      name = _ref2.name,
      onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      $css = _ref2.$css,
      className = _ref2.className,
      hiddenLabel = _ref2.hiddenLabel,
      collapseError = _ref2.collapseError,
      helperText = _ref2.helperText,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useExtendedField = useExtendedField({
    name: name,
    type: 'select'
  }, {
    onChange: onChange,
    errorText: errorText
  }),
      _useExtendedField2 = _slicedToArray(_useExtendedField, 2),
      _useExtendedField2$ = _useExtendedField2[0],
      _onBlur = _useExtendedField2$.onBlur,
      formikFieldConfig = _objectWithoutProperties(_useExtendedField2$, _excluded2),
      _useExtendedField2$2 = _useExtendedField2[1],
      error = _useExtendedField2$2.errorText,
      value = _useExtendedField2$2.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var idRef = useRef(dotToDash(name)).current;
  return /*#__PURE__*/React.createElement(Div, {
    $css: $css,
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    $css: css(["margin-bottom:", "px;"], SPACINGS.L),
    htmlFor: idRef,
    label: label,
    placeholder: placeholder,
    hiddenLabel: hiddenLabel
  }), /*#__PURE__*/React.createElement(SelectWrapper, {
    className: "select-wrapper",
    $disabled: disabled,
    $error: !!error,
    $focus: focused,
    $readOnly: readOnly
  }, /*#__PURE__*/React.createElement(SelectElement, _extends({
    "data-test-id": idRef,
    id: idRef
  }, rest, formikFieldConfig, {
    disabled: disabled,
    readOnly: readOnly,
    onFocus: function onFocus(e) {
      setFocused(isKeyboard(e));
    },
    $hasValue: !!value,
    onBlur: function onBlur(e) {
      _onBlur(e);

      setFocused(false);
    }
  }, addInputErrorAriaProps(error, idRef, rest)), placeholder && /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder), children), /*#__PURE__*/React.createElement(ArrowContainer, null, /*#__PURE__*/React.createElement(CaretDown, {
    color: disabled ? COLORS.NEUTRAL_300 : COLORS.NEUTRAL_400
  }))), helperText && !error && /*#__PURE__*/React.createElement(HelperText, {
    disabled: disabled,
    $css: css(["display:block;margin-top:8px;"])
  }, helperText), !disableErrorContainer && (!helperText || errorText) && /*#__PURE__*/React.createElement(InputError, {
    errorText: error,
    collapseError: collapseError,
    errorId: idRef
  }));
};

export default Select;